import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ShinySkeletonText } from 'crm-events-components/internal/skeletons/helpers/skeletonHelpers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { isLoading } from 'crm_data/flux/LoadingStatus';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExpandCollapseValue({
  isCollapsedByDefault
}) {
  const isDefaultValueLoading = isLoading(isCollapsedByDefault);
  if (isDefaultValueLoading) {
    return /*#__PURE__*/_jsx(ShinySkeletonText, {
      "data-test-id": "expand-collapse-skeleton"
    });
  }
  return isCollapsedByDefault ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.timelineControls.expandCollapseAllToggle.collapseAll"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.timelineControls.expandCollapseAllToggle.expandAll"
  });
}
ExpandCollapseValue.propTypes = {
  isCollapsedByDefault: PropTypes.bool
};
export default ExpandCollapseValue;